import React, { useMemo } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import validator from "validator";
import { AxiosError } from "axios";
import { Form, Formik, FormikHelpers, FormikValues } from "formik";
import axiosInstant from "../../api";
import { postForgotPassword } from "../../api/endpoints";
import {
  BasicPage,
  ForgetPassFormInitialValues as initValues,
  FormButton,
  AuthCard,
} from "./components";

export function PostForgetPasswordPage() {
  const { email } = useParams();
  const navigate = useNavigate();

  const emailAddress = useMemo(
    () => (email && validator.isEmail(email) ? email : ""),
    [email]
  );

  const handleSubmit = async (
    values: FormikValues,
    helpers: FormikHelpers<typeof initValues>
  ) => {
    helpers.setSubmitting(true);
    try {
      await axiosInstant.post(postForgotPassword(), values);
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        const { data } = axiosError.response;
        const formError = typeof data === "string" ? data : data.error;
        helpers.setErrors({ form: formError });
      }
    }
    helpers.setSubmitting(false);
  };

  return (
    <BasicPage>
      <AuthCard elevation={0} variant="outlined">
        <Box textAlign="center" display="flex" flexDirection="column" gap={5}>
          <Box display="flex" flexDirection="column" gap={2}>
            <Typography variant="h5" className="px-8">
              Recovery email successfully sent
            </Typography>
            <Typography variant="body1" color="var(--text-2)" className="px-6">
              We{`'`}ve sent a password recovery email to the email address you
              provided. Please check your inbox for further instructions.
            </Typography>
            {emailAddress && (
              <Typography variant="body1" color="var(--text)" className="px-6">
                {emailAddress}
              </Typography>
            )}
          </Box>
          <Stack justifyContent="center" spacing={1}>
            <FormButton text="Back to login" onClick={() => navigate("/")} />
            {emailAddress && (
              <Formik
                initialValues={{ emailAddress, form: null }}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <FormButton
                      isLoadingBtn
                      loading={isSubmitting}
                      variant="outlined"
                      color="inherit"
                      text="Send recovery email again"
                      className="!bg-surface-2 !border-0 hover:!bg-track !text-text-2"
                    />
                  </Form>
                )}
              </Formik>
            )}
          </Stack>
        </Box>
      </AuthCard>
      <div className="h-5" />
    </BasicPage>
  );
}
